module.exports = __webpack_public_path__ + "static/team-lewis-86544b719249f7c3b5b8b726fe309083.jpg";